<template>
  <div class="reamrk-com-list-main-page">
    <main-header :hasBanner="true" :type="'companyRemark'"></main-header>
    <section class="main-center list-clr">
      <list-left :type="'comRemark'"></list-left>
      <div class="page-right">
        <div class="right-top">
          <div class="right-title">机构公众评价</div>
        </div>

        <el-table stripe :data="tableData" border style="width: 100%">
          <el-table-column
            align="centet"
            header-align="center"
            prop="name"
            label="经纪机构名称"
          ></el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="districtName"
            label="行政区"
          ></el-table-column>
          <!-- <el-table-column
            align="centet"
            header-align="center"
            prop=""
            label="评价"
          ></el-table-column> -->
          <el-table-column
            align="centet"
            header-align="center"
            label="更多评价"
          >
            <template slot-scope="scope">
              <img
                @click="goDetail(scope.row)"
                style="width: 20px; cursor: pointer"
                src="@/assets/img/search.png"
                alt=""
              />
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          class="bottom-pagination"
          background
          @current-change="handleCurrentChange"
          :current-page="pagingObj.pageNum"
          :page-size="pagingObj.pageSize"
          layout="prev, pager, next, jumper, total "
          :total="total"
        >
        </el-pagination>
      </div>
    </section>
    <main-footer></main-footer>
  </div>
</template>

<script>
import vueQr from "vue-qr";
import mainHeader from "@/components/mainHeader";
import mainFooter from "@/components/mainFooter";
import listLeft from "@/components/listLeft";
import { districtList } from "@/assets/api/common";
import { companyList } from "@/assets/api/company";

export default {
  name: "App",
  components: {
    mainHeader,
    mainFooter,
    vueQr,
    listLeft,
  },

  data() {
    return {
      options: [],
      tableData: [],
      pagingObj: {
        districtId: "",
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
    };
  },
  computed: {},
  async mounted() {
    this.getData();
    this.initCity();
  },
  methods: {
    async initCity() {
      const res = await districtList();
      this.options = ((res && res.data && res.data.data) || []).map((item) => {
        return {
          value: item.id,
          label: item.name,
        };
      });
      this.options.unshift({
        value: null,
        label: "全部",
      });
    },
    goDetail(item) {
      const jumpUrl = this.$router.resolve({
        path: "/company/remark",
        query: { id: item.id },
      });
      window.open(jumpUrl.href, "_blank");
    },
    showCode(i) {
      this.$set(this.tableData[i], "showCode", true);
    },
    hideCode(i) {
      this.$set(this.tableData[i], "showCode", false);
    },
    handleCurrentChange(val) {
      this.pagingObj.pageNum = val;
      this.getData();
    },
    search() {
      this.pagingObj.pageNum = 1;
      this.getData();
    },
    async getData() {
      const res = await companyList(this.pagingObj);
      if (res && res.data && res.data.code == 200) {
        this.tableData = res.data.rows || [];
        this.tableData = this.tableData.map((item) => {
          return {
            ...item,
            mobileUrl: `${this.$globalData.serverUrl}/#/mCompanyDetail?id=${item.id}`,
          };
        });
        this.total = res.data.total;
      }
    },
  },
};
</script>

<style lang="less">
.reamrk-com-list-main-page {
  background: #fff;
  .list-clr {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;

    .page-right {
      flex: 1;
      .right-top {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .right-title {
          font-size: 18px;
          color: #222;
        }
        .ad-select {
          width: 203px;
          input {
            height: 50px;
            border-radius: 0;
          }
        }
        .ad-input {
          width: 520px;
          height: 50px;
          border: 1px solid #dcdfe6;
          border-left: 0;
          border-right: 0;
          input {
            height: 100%;
            border: none;
          }
        }
        .search-btn {
          background: #9b2f3d;
          width: 140px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          color: #fff;
          font-weight: bold;
          font-size: 16px;
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
          cursor: pointer;
        }
      }
    }
  }
  .mg-t20 {
    margin-top: 20px;
  }
  .el-table .cell {
  }

  .el-table .cell {
    overflow: initial !important;
  }
  .el-table {
    overflow: initial !important;
  }
  .el-table__body-wrapper {
    overflow: initial !important;
  }
  .qr-box {
    position: relative;
    z-index: 2;
    img {
      position: absolute;
      z-index: 1;
      left: -50px;
      top: 10px;
    }
  }
  .bottom-pagination {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-left: 0;
    padding-right: 0;
    .el-pagination__total {
    }
  }
}
</style>